import { Helmet } from "react-helmet";
import { useRouteError, Link } from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    return (
        <div>
            <Helmet>
                <title>Fiska\Group - Erreur</title>
            </Helmet>

            <div id="error-page" style={{ textAlign: "center", marginTop: "50px" }}>
                <h1>Oups !</h1>
                <p>Désolé, une erreur inattendue est survenue.</p>
                <p>
                    <i>{error.statusText || error.message}</i>
                </p>
                <Link to="/" style={{ display: "inline-block", marginTop: "20px", color: "#007bff", textDecoration: "underline" }}>
                    Retour à l’accueil
                </Link>
            </div>
        </div>
    );
}